export default {
    primary: 'adelle-sans',
    secondary: 'ff-tisa-web-pro',
    baseSize: 1.3,
    lineHeight: '30px',
    fontSize: '19px',
}
